// Polls GET /backtest every 5s so card statuses (pending → running → done)
// refresh without manual reloads. No WS channel for backtests.
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";
import type { BacktestRecord } from "@/types/api";

export function useBacktests() {
  return useQuery<BacktestRecord[]>({
    queryKey: ["backtests"],
    queryFn: () => apiGet<BacktestRecord[]>("/backtest"),
    refetchInterval: 5000,
  });
}
